import { render, staticRenderFns } from "./TabTravelPackage.vue?vue&type=template&id=32024114"
import script from "./TabTravelPackage.vue?vue&type=script&lang=ts"
export * from "./TabTravelPackage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports